import React, {Component} from 'react';
import bus from './bus';
import './app.css';
import './weui.css';
import QRCode from './qrcode';
import BindEmail from './bind-email';
import BindPhone from './bind-phone';
import Eidt from './edit';
import Result from './result';
import Register from './register';
import Manager from './manager';
import Remain from './remain';

class App extends Component {
    constructor(props) {
        super(props);
        let hash = window.location.hash;
        this.state = {view: hash, result: {result: false, error: ''}};
        this.onShowTips = this.onShowTips.bind(this);
        this.onResult = this.onResult.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onView = this.onView.bind(this);
    }

    componentDidMount() {
        bus.on('view', this.onView);
        bus.on('result', this.onResult);
        bus.on('edit', this.onEdit);
        bus.on('showTips', this.onShowTips);
    }

    componentWillUnmount() {
        bus.off('view', this.onView);
        bus.off('result', this.onResult);
        bus.off('edit', this.onEdit);
        bus.off('showTips', this.onShowTips);
    }

    onShowTips(msg) {
        alert(msg);
    }

    onResult(msg) {
        this.setState({result: msg});
        bus.emit('view', '#result');
    }

    onEdit(id) {
        this.setState({edit: id});
        bus.emit('view', '#edit');
    }

    onView(view) {
        this.setState({view: view});
    }

    getView() {
        console.log(this.state.view);
        switch (this.state.view) {
            case '#qrcode':
                return (<QRCode/>);
            case '#bind_email':
                return (<BindEmail/>);
            case '#bind_phone':
                return (<BindPhone/>);
            case '#edit':
                return (<Eidt id={this.state.edit}/>);
            case '#manager':
                return (<Manager/>);
            case '#register':
                return (<Register/>);
            case '#result':
                return (<Result msg={this.state.result}/>);
            case '#remain':
                return (<Remain/>);
            default:
                return (<QRCode/>);
        }
    }

    render() {
        let content = this.getView();
        return (
            <div className="app">
                {content}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/app.js